export default "__VITE_ASSET__ByJ8Otz9__"